import { render, staticRenderFns } from "./OfferPlayerItem.vue?vue&type=template&id=6961bcf6&"
import script from "./OfferPlayerItem.vue?vue&type=script&lang=js&"
export * from "./OfferPlayerItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports